import { type UseQueryOptions } from "@tanstack/react-query";

import { useApiDeprecated } from "../../context";
import { type PaginatedResponse, useHermesQuery } from "../common";
import type { DoctorExpanded } from "./definitions";

type UseV1PremiumDoctorsExpandedParams = {
  city?: number;
  service?: number[];
  exclude?: number[];
};
type UseV1PremiumDoctorsExpandedResult = PaginatedResponse<DoctorExpanded[]>;
type UseV1PremiumDoctorsExpandedOptions =
  UseQueryOptions<UseV1PremiumDoctorsExpandedResult>;

export const useV1PremiumDoctorsExpanded = (
  params: UseV1PremiumDoctorsExpandedParams,
  options?: Partial<UseV1PremiumDoctorsExpandedOptions>,
) => {
  const { api } = useApiDeprecated();
  const url = `/api/v1/doctors/premium/`;

  return useHermesQuery({
    queryKey: [url, params],
    queryFn: async () => {
      return api(
        {
          url,
          method: "GET",
          params: {
            ...params,
            service: params.service?.join(","),
            exclude: params.exclude?.join(","),
            expand: ["clinic_branches", "clinic_branches_", "services"].join(
              ",",
            ),
          },
        },
        {
          200: async (r) => r.data,
        },
      );
    },
    ...options,
  });
};
